<script>
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import BankSearch from "@/view/components/BankSearch.vue";
import uploadImg from "@/components/uploadImg/index.vue";
import urlConfig from "@/utils/urlConfig";
import {commonDict} from "@/utils/bizDict/commonDict";


export default {
  name: "EnterpriseReligionOpen",
  components: {DepartmentChoose, BankSearch, uploadImg},
  data() {
    return {
      companylist: [],
      religiousTypeList: [],


      currentStep: 1,
      totalSteps: 6,
      progress: 0,
      stepStatus: Array(7).fill("wait"),
      stepTitles: [
        "渠道信息",
        "宗教对公信息",
        "宗教信息",
        "负责人信息",
        "信息确认",
        "完成提交"
      ],
      formData: {
        // 渠道信息
        deptId: null,                 // 所属机构 ID
        deptCode: "",                 // 所属机构编码
        channelNo: "",                // 渠道编号（归属渠道）
        appNo: "",                    // 应用编号（从渠道信息自动回填）


        // 对公信息
        accountProperty: "3",
        primaryAccount: "",           // 对公卡号
        bankNo: "",                   // 开户行编号
        bankName: "",                 // 开户行名称
        mobile: "",                   // 联系电话

        // 宗教信息
        religiousType: "",            // 宗教类型（字典 commonDict.religionTypes）
        accountName: "",              // 宗教名称
        idNo: "",                     // 统一社会信用代码
        idType: "D",
        idAddress: "",                // 注册地址
        zsopscope: "",                // 经营范围
        idStartDate: "",              // 发放日
        idEndDate: "",                // 到期日

        // 法人信息
        legalRepName: "",             // 法人姓名
        legalRepIdNo: "",             // 法人证件号码
        legalRepOpto: "",             // 法人证件有效期

        // 负责人信息
        leaderIdName: "",             // 负责人姓名
        leaderIdNo: "",               // 负责人证件号码
        leaderOpto: "",               // 负责人证件有效期
        leaderMobile: "",             // 负责人手机号
        religiousDharmaName: "",      // 负责人法名（如释唯信）
        religiousSecularName: "",     // 负责人俗名（身份证姓名）

        // 附件
        files: []                     // 上传附件数组（含 OCR 回填 fileNo、channelFileNo、fileUrl、fileType、filePage）
      },

      headers: {token: sessionStorage.getItem("token")},
      busiURL: urlConfig.busiURL + "/base/ocr/recognizeIdcard",
      ocrBusilistenURL: urlConfig.busiURL + "/base/ocr/recognizeBusinessLicense",

      // OCR 展示控制
      bizVisible: false,
      religActVisible: false,


      legFrontVisible: false,
      legBackVisible: false,

      leaFrontVisible: false,
      leaBackVisible: false,

      dharmaCertVisible: false,


      // OCR 回填数据
      bizOCR: {},
      legalInfo: {},
      // 校验规则
      allRules: {
        1: {
          deptId: [{required: true, message: "请选择机构", trigger: "change"}],
          channelNo: [{required: true, message: "请选择渠道归属", trigger: "change"}],
        },
        2: {
          primaryAccount: [{required: true, message: "请输入对公卡号", trigger: "blur"}],
          bankNo: [{required: true, message: "请选择开户行", trigger: "change"}],
          mobile: [
            {required: true, message: "请输入联系电话", trigger: "blur"},
            {pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur"}
          ],
        },
        3: {
          religiousType: [{required: true, message: "请选择宗教类型", trigger: "change"}],
          accountName: [{required: true, message: "请输入宗教名称", trigger: "blur"}],
          zsopscope: [{required: true, message: "请输入经营范围", trigger: "blur"}],
          signName: [{required: true, message: "请输入签发机关", trigger: "blur"}],
          religiousCertNo: [{required: true, message: "请输入宗教场所登记证号", trigger: "blur"}],
          creditCode: [{required: true, message: "请输入统一社会信用代码", trigger: "blur"}],
          idAddress: [{required: true, message: "请输入注册地址", trigger: "blur"}],
          idStartDate: [{required: true, message: "请选择发放日", trigger: "change"}],
          idEndDate: [{required: true, message: "请选择到期日", trigger: "change"}],
        },
        4: {
          leaderIdName: [{required: true, message: "请输入负责人姓名", trigger: "blur"}],
          leaderIdNo: [{required: true, message: "请输入负责人证件号码", trigger: "blur"}],
          leaderOpto: [{required: true, message: "请选择负责人证件有效期", trigger: "change"}],
          leaderMobile: [
            {required: true, message: "请输入负责人手机号", trigger: "blur"},
            {pattern: /^1[3-9]\d{9}$/, message: "手机号格式不正确", trigger: "blur"}
          ],
          religiousDharmaName: [{required: true, message: "请输入负责人法名", trigger: "blur"}],
          religiousSecularName: [{required: true, message: "请输入负责人俗名", trigger: "blur"}],
        },
      }

    };
  },
  computed: {
    commonDict() {
      return commonDict
    },

    currentRules() {
      return this.allRules[this.currentStep] || {};
    },
    progressColor() {
      if (this.progress < 33) return "#ff4d4f";
      if (this.progress < 66) return "#faad14";
      return "#52c41a";
    },

  },
  watch: {
    currentStep(val) {
      // 更新进度条
      this.progress = Math.round(((val - 1) / (this.totalSteps - 1)) * 100);
      // 更新步骤状态
      this.stepStatus = this.stepStatus.map((_, i) => i < val - 1 ? "finish" : (i === val - 1 ? "process" : "wait"));
    }
  },
  created() {
    this.getChannelList();
  },
  methods: {

    channelChange(val) {
      this.companylist.forEach((item) => {
        if (Number(val) == Number(item.value)) {
          this.formData.appNo = item.info.appNo;
        }
      });
    },

    // 获取渠道列表
    async getChannelList() {
      const res = await this.api.coreCompanyInfoApi();
      if (res.code !== 200) {
        this.$message.error(res.info || "获取渠道列表失败");
        return;
      }
      this.companylist = res.data.map(item => ({
        label: `${item.channelName}（${item.channelNo}）`,
        value: item.channelNo,
        info: item
      }));
      if (this.companylist.length === 1) {
        this.formData.channelNo = this.companylist[0].value;
        this.channelChange(this.formData.channelNo);
      }
    },


    nextStep() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.currentStep++;
          console.log("第"+this.currentStep+"步骤验证成功", this.formData)
        } else {
          this.$message.error("请完整填写当前步骤表单信息");
        }
      });
    },

    prevStep() {
      if (this.currentStep > 1) this.currentStep--;
    },
    goHome() {
      this.$router.push("/cust/acctregPage");
    },
    handleBeforeUpload(file) {
      const ok = file.size / 1024 / 1024 < 5;
      if (!ok) this.$message.error("请上传小于 5MB 的文件");
      return ok;
    },

    formatDate(rawDate) {
      if (!rawDate) return '';

      // 场景1：纯数字格式 (如 "20110513")
      if (/^\d{8}$/.test(rawDate)) {
        const year = rawDate.substr(0, 4);
        const month = rawDate.substr(4, 2);
        const day = rawDate.substr(6, 2);
        return `${year}-${month}-${day}`;
      }

      // 场景2：中文格式 (如 "2011年05月13日")
      if (rawDate.includes("年")) {
        return rawDate
            .replace("年", "-")
            .replace("月", "-")
            .replace("日", "");
      }

      // 场景3：带点格式 (如 "2025.07.09")
      if (rawDate.includes(".")) {
        return rawDate.replace(/\./g, "-"); // 替换所有点
      }

      // 场景4：包含斜杠格式 (如 "2025/07/09")
      if (rawDate.includes("/")) {
        return rawDate.replace(/\//g, "-");
      }

      // 场景5：若为 Date 类型，转标准格式
      if (rawDate instanceof Date) {
        const year = rawDate.getFullYear();
        const month = String(rawDate.getMonth() + 1).padStart(2, "0");
        const day = String(rawDate.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }

      // 场景6：其他情况直接返回
      return rawDate;
    },


    /**
     * 公共方法：下载 OCR 图片并回填 files
     */
    async handleOcrFileReturn(res, fileType) {
      let imagePath = "";
      try {
        const imgRes = await this.api.downloadImage(res.data.file_no);
        if (imgRes.code === 200) {
          imagePath = imgRes.data;
        } else {
          console.warn("图片下载失败:", imgRes.info);
        }
      } catch (error) {
        console.error(`下载失败: ${error.message}`);
      }

      this.formData.files = this.formData.files.filter(f => f.fileType !== fileType);
      this.formData.files.push({
        fileNo: res.data.file_no,
        imagePath: imagePath,
        channelFileNo: res.data.channel_file_no,
        fileType: fileType,
        filePage: 1,
        fileUrl: res.data.file_path
      });
    },



    // === 宗教活动场所登记证 OCR ===
    onReligActChange(info) {
      this.$refs['religActUp'].handleChangeUpload(info, "");
    },
    async onReligActOCR(res) {
      if (res.code !== 200) return;
      await this.handleOcrFileReturn(res, "12");
    },




    // === 负责人正面 OCR ===
    onLeaderFrontChange(info) {
      this.$refs['leaFront'].handleChangeUpload(info, "");
    },
    async onLeaderFrontOCR(res) {
      if (res.code !== 200) return;
      const o = res.data.ocrRecognizeResult;
      this.formData.leaderIdType =  '1';
      this.formData.leaderIdName = o.name;
      this.formData.leaderIdNo = o.idcard;

      this.formData.legalRepIdType = '1';
      this.formData.legalRepIdNo = o.idcard;
      this.formData.legalRepName = o.name;
      //受益人
      this.formData.beneName = o.name;
      this.formData.beneIdType = '1';
      this.formData.beneIdNo = o.idcard;
      this.formData.beneSex = o.sex === '女' ? '1' : '0';

      this.formData.birthdt = o.birth.replace('年', '-').replace('月', '-').replace('日', '');
      this.formData.beneAddr = o.address
      this.formData.beneNationality = "156"
      this.formData.beneRatio = "100"


      await this.handleOcrFileReturn(res, "01");
    },

    // === 负责人反面 OCR ===
    onLeaderBackChange(info) {
      this.$refs['leaBack'].handleChangeUpload(info, "");
    },
    async onLeaderBackOCR(res) {
      if (res.code !== 200) return;
      const o = res.data.ocrRecognizeResult;
      this.formData.leaderOpto = o.validDate.includes('长期') ? "9999-12-31" : this.formatDate(o.validDate.substr(11, 10));
      this.formData.legalRepOpto = o.validDate.includes('长期') ? "9999-12-31" : this.formatDate(o.validDate.substr(11, 10));
      //受益人
      this.formData.beneOpto = o.validDate.includes('长期') ? "9999-12-31" : this.formatDate(o.validDate.substr(11, 10));
      await this.handleOcrFileReturn(res, "02");
    },

    // === 宗教教职人员资格证 OCR ===
    onDharmaCertChange(info) {
      this.$refs['dharmaCert'].handleChangeUpload(info, "");
    },
    async onDharmaCertOCR(res) {
      if (res.code !== 200) return;
      await this.handleOcrFileReturn(res, "103");
    },


    // === 提交 ===
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          console.log('提交数据：', this.formData); // 可替换为API调用

          try {
            const rsp = await this.api.addAcctReg(this.formData);
            if (rsp.code !== 200) {
              this.$message.error(rsp.info);
              return;
            }
            // 成功后进入第五步
            this.nextStep();
          } catch (e) {
            console.error(e);
            this.$message.error('提交失败，请稍后再试');
          }
        } else {
          this.$message.error('请填写必填字段');
        }
      });
    },
    previewFile(file) {
      if (file.imagePath) {
        window.open(file.imagePath, '_blank');
      } else {
        this.$message.warning('无法预览：附件未上传或未生成预览链接');
      }
    },
    isImage(url) {
      try {
        const cleanUrl = new URL(url).pathname; // 只取路径部分
        return /\.(jpeg|jpg|gif|png|bmp|webp)$/i.test(cleanUrl);
      } catch (e) {
        console.error("Invalid URL for isImage:", url, e);
        return false;
      }
    },
    newApplication() {
      this.$refs.form.resetFields();
      this.formData.files = [];
      this.currentStep = 1;
      this.progress = 0;
      this.stepStatus = Array(5).fill('wait');
    },


  },
  mounted() {
    // 初始状态
    this.currentStep = 1;
  }
};
</script>
<template>
  <div class="registration-container">
    <a-page-header
        title="宗教开户登记"
        sub-title="请按步骤完成信息填写"
        @back="goHome"
    >
      <template #extra>
        <a-button type="primary"  @click="goHome">返回</a-button>
      </template>
    </a-page-header>
    <!-- 进度条 -->
    <div class="progress-container">
      <a-progress
          :percent="progress"
          :stroke-color="progressColor"
          :show-info="false"
          class="progress-bar"
      />
      <div class="progress-info">
        <span class="progress-text">完成进度: {{ progress }}%</span>
      </div>
    </div>

    <!-- 步骤条 -->
    <div class="steps-container">
      <a-steps :current="currentStep - 1">
        <a-step v-for="(title, index) in stepTitles" :key="index" :title="title" :status="stepStatus[index]"/>
      </a-steps>
    </div>

    <a-form-model
        ref="form"
        :model="formData"
        :rules="currentRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
    >
      <!-- 渠道信息 -->
      <div v-show="currentStep === 1">
        <a-form-model-item label="所属机构" prop="deptId">
          <DepartmentChoose
              :department-id.sync="formData.deptId"
              :department-code.sync="formData.deptCode"
              :default-first="false"
          />
        </a-form-model-item>
        <a-form-model-item label="渠道归属" prop="channelNo">
          <a-select v-model="formData.channelNo" @change="channelChange">
            <a-select-option
                v-for="item in companylist"
                :key="item.value"
                :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </div>

      <!-- 对公信息 -->
      <div v-show="currentStep === 2">
        <a-form-model-item label="对公卡号" prop="primaryAccount">
          <a-input v-model="formData.primaryAccount"/>
        </a-form-model-item>
        <a-form-model-item label="开户行/网点" prop="bankNo">
          <BankSearch :bankNo.sync="formData.bankNo" :bankName.sync="formData.bankName"/>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="mobile">
          <a-input v-model="formData.mobile" placeholder="请输入联系电话"/>
        </a-form-model-item>
      </div>

      <!-- 宗教信息 -->
      <div v-show="currentStep === 3">
        <a-form-model-item label="宗教活动场所登记证">
          <div class="row">
            <div class="item">
              <a-upload
                  accept="image/*"
                  :before-upload="handleBeforeUpload"
                  :action="`/business/file/manager/upload?channel_no=${this.formData.channelNo}`"
                  :headers="headers"
                  :show-upload-list="false"
                  @change="onReligActChange"
              >
                <uploadImg
                    v-show="religActVisible"
                    ref="religActUp"
                    @completedUpload="onReligActOCR"
                    @onloadsuccsse="religActVisible = $event"
                />
                <div v-show="!religActVisible">
                  <a-icon type="plus"/>
                  上传登记证
                </div>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>

        <a-form-model-item label="宗教类型" prop="religiousType">
          <a-radio-group v-model="formData.religiousType">
            <template v-for="(type, val) in commonDict.religionTypes">
              <a-radio-button v-if="type.show" :key="val" :value="val">{{ type.label }}</a-radio-button>
            </template>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="宗教名称" prop="accountName">
          <a-input v-model="formData.accountName" placeholder="请输入宗教名称"/>
        </a-form-model-item>


        <a-form-model-item label="宗教场所登记证号" prop="religiousCertNo">
          <a-input v-model="formData.religiousCertNo" placeholder="请输入宗教场所登记证号 格式如“宗场证字（浙）f030050210号”，需符合登记机关编号规则'"/>
        </a-form-model-item>

        <a-form-model-item label="统一社会信用代码" prop="creditCode">
          <a-input v-model="formData.creditCode" placeholder="请输入统一社会信用代码"/>
        </a-form-model-item>

        <a-form-model-item label="签发机关" prop="signName">
          <a-input v-model="formData.signName" placeholder="请输入签发机关"/>
        </a-form-model-item>

        <a-form-model-item label="注册地址" prop="idAddress">
          <a-input v-model="formData.idAddress" placeholder="请输入注册地址"/>
        </a-form-model-item>

        <a-form-model-item label="经营范围" prop="zsopscope">
          <a-input v-model="formData.zsopscope" placeholder="请输入经营范围"/>
        </a-form-model-item>

        <a-form-model-item label="发放日" prop="idStartDate">
          <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" v-model="formData.idStartDate"/>
        </a-form-model-item>

        <a-form-model-item label="到期日" prop="idEndDate">
          <a-date-picker style="width: 200px" valueFormat="YYYY-MM-DD" v-model="formData.idEndDate"/>
        </a-form-model-item>
      </div>



      <!-- 负责人信息 -->
      <div v-show="currentStep === 4">
        <a-form-model-item label="负责人身份证上传">
          <div class="row">
            <div class="item">
              <a-upload
                  accept="image/*"
                  :before-upload="handleBeforeUpload"
                  :action="busiURL"
                  :headers="headers"
                  :show-upload-list="false"
                  @change="onLeaderFrontChange"
              >
                <uploadImg
                    v-show="leaFrontVisible"
                    ref="leaFront"
                    @completedUpload="onLeaderFrontOCR"
                    @onloadsuccsse="leaFrontVisible = $event"
                />
                <div v-show="!leaFrontVisible">
                  <a-icon type="plus"/>
                  身份证正面
                </div>
              </a-upload>
            </div>
            <div class="item">
              <a-upload
                  accept="image/*"
                  :before-upload="handleBeforeUpload"
                  :action="busiURL"
                  :headers="headers"
                  :show-upload-list="false"
                  @change="onLeaderBackChange"
              >
                <uploadImg
                    v-show="leaBackVisible"
                    ref="leaBack"
                    @completedUpload="onLeaderBackOCR"
                    @onloadsuccsse="leaBackVisible = $event"
                />
                <div v-show="!leaBackVisible">
                  <a-icon type="plus"/>
                  身份证反面
                </div>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>

        <a-form-model-item label="负责人戒碟上传">
          <div class="row">
            <div class="item">
              <a-upload
                  accept="image/*"
                  :before-upload="handleBeforeUpload"
                  :action="`/business/file/manager/upload?channel_no=${this.formData.channelNo}`"
                  :headers="headers"
                  :show-upload-list="false"
                  @change="onDharmaCertChange"
              >
                <uploadImg
                    v-show="dharmaCertVisible"
                    ref="dharmaCert"
                    @completedUpload="onDharmaCertOCR"
                    @onloadsuccsse="dharmaCertVisible = $event"
                />
                <div v-show="!dharmaCertVisible">
                  <a-icon type="plus"/>
                  上传负责人戒碟
                </div>
              </a-upload>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item label="负责人姓名" prop="leaderIdName">
          <a-input v-model="formData.leaderIdName" placeholder="请输入负责人姓名"/>
        </a-form-model-item>
        <a-form-model-item label="负责人证件号码" prop="leaderIdNo">
          <a-input v-model="formData.leaderIdNo" placeholder="请输入证件号码"/>
        </a-form-model-item>
        <a-form-model-item label="证件有效期" prop="leaderOpto">
          <a-date-picker v-model="formData.leaderOpto" valueFormat="YYYY-MM-DD" style="width: 100%"/>
        </a-form-model-item>
        <a-form-model-item label="负责人手机号码" prop="leaderMobile">
          <a-input v-model="formData.leaderMobile" placeholder="请输入手机号码"/>
        </a-form-model-item>
        <a-form-model-item label="负责人法名" prop="religiousDharmaName">
          <a-input v-model="formData.religiousDharmaName" placeholder="请输入法名如“释唯信”，需与负责人证件关联"/>
        </a-form-model-item>
        <a-form-model-item label="负责人俗名" prop="religiousSecularName">
          <a-input v-model="formData.religiousSecularName" placeholder="请输入俗名，应填写负责人身份证姓名"/>
        </a-form-model-item>


      </div>

      <!-- 信息确认 -->
      <div v-show="currentStep === 5">
        <a-descriptions bordered :column="2">
          <a-descriptions-item label="所属机构">{{ formData.deptCode }}</a-descriptions-item>
          <a-descriptions-item label="渠道归属">{{ formData.channelNo }}</a-descriptions-item>
          <a-descriptions-item label="对公卡号">{{ formData.primaryAccount }}</a-descriptions-item>
          <a-descriptions-item label="开户行">{{ formData.bankName }}</a-descriptions-item>
          <a-descriptions-item label="联系电话">{{ formData.mobile }}</a-descriptions-item>

          <a-descriptions-item label="宗教类型">{{ commonDict.religionTypes[formData.religiousType]?.label }}</a-descriptions-item>
          <a-descriptions-item label="宗教名称">{{ formData.accountName }}</a-descriptions-item>
          <a-descriptions-item label="统一社会信用代码">{{ formData.creditCode }}</a-descriptions-item>
          <a-descriptions-item label="注册地址">{{ formData.idAddress }}</a-descriptions-item>
          <a-descriptions-item label="发放日">{{ formData.idStartDate }}</a-descriptions-item>
          <a-descriptions-item label="到期日">{{ formData.idEndDate }}</a-descriptions-item>

          <a-descriptions-item label="法人姓名">{{ formData.legalRepName }}</a-descriptions-item>
          <a-descriptions-item label="法人证件号码">{{ formData.legalRepIdNo }}</a-descriptions-item>
          <a-descriptions-item label="法人证件有效期">{{ formData.legalRepOpto }}</a-descriptions-item>

          <a-descriptions-item label="负责人姓名">{{ formData.leaderIdName }}</a-descriptions-item>
          <a-descriptions-item label="负责人证件号码">{{ formData.leaderIdNo }}</a-descriptions-item>
          <a-descriptions-item label="负责人证件有效期">{{ formData.leaderOpto }}</a-descriptions-item>
          <a-descriptions-item label="负责人手机号">{{ formData.leaderMobile }}</a-descriptions-item>
          <a-descriptions-item label="负责人法名">{{ formData.religiousDharmaName }}</a-descriptions-item>
          <a-descriptions-item label="负责人俗名">{{ formData.religiousSecularName }}</a-descriptions-item>
          <a-descriptions-item label="附件" :span="3">
            <div class="file-thumbnails">
              <div
                  v-for="file in formData.files"
                  :key="file.fileNo"
                  class="thumbnail-container"
                  @click="previewFile(file)"
              >
                <img
                    v-if="isImage(file.imagePath)"
                    :src="file.imagePath"
                    alt="附件缩略图"
                    class="thumbnail-image"
                />
                <div v-else class="thumbnail-pdf">
                  <a-icon type="file-pdf" style="font-size: 36px; color: #d32f2f"/>
                  <div style="font-size: 12px; color: #666; margin-top: 4px;">
                    PDF预览
                  </div>
                </div>
              </div>
              <div v-if="!formData.files || !formData.files.length">
                暂无附件
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </div>


      <!-- 完成提交 -->
      <div v-show="currentStep === 6">
        <a-result
            status="success"
            title="开户申请提交成功"
            sub-title="系统将在1-3个工作日完成审核，请耐心等待"
        >
          <template #extra>
            <a-button type="primary" @click="newApplication">新申请</a-button>
          </template>
        </a-result>
      </div>

      <div v-show="currentStep < 6" class="step-btn-bar">
        <a-button v-if="currentStep > 1" @click="prevStep">上一步</a-button>
        <a-button type="primary" @click="currentStep < 5 ? nextStep() : submitForm()">
          {{ (currentStep < 5) ? "下一步" : "提交申请" }}
        </a-button>
      </div>
    </a-form-model>
  </div>
</template>


<style scoped lang="less">
.step-btn-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  margin-bottom: 24px;
}
.registration-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);

  .page-header {
    background: transparent;
    padding: 0;
    margin-bottom: 20px;
  }

  .progress-container {
    margin-bottom: 30px;
    position: relative;

    .progress-bar {
      border-radius: 8px;
      overflow: hidden;
    }

    .progress-info {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;

      .progress-text {
        font-size: 14px;
        color: #595959;
        font-weight: 500;
      }
    }
  }

  .steps-container {
    margin-bottom: 30px;

    /deep/ .ant-steps-item-process .ant-steps-item-icon {
      background: #1890ff;
      border-color: #1890ff;
    }

    /deep/ .ant-steps-item-finish .ant-steps-item-icon {
      background-color: #fff;
      border-color: #1890ff;

      .ant-steps-icon {
        color: #1890ff;
      }
    }
  }

  .account-form {
    padding: 20px;
    background: #fafafa;
    border-radius: 4px;
    border: 1px solid #f0f0f0;

    .form-step {
      margin-bottom: 24px;
      padding: 24px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      .step-title {
        font-size: 16px;
        font-weight: 600;
        color: #1890ff;
        margin-bottom: 24px;
        padding-bottom: 12px;
        border-bottom: 1px solid #e8f3ff;
      }
    }

    .success-step {
      text-align: center;
      padding: 40px 20px;
    }

    .file-section {
      padding: 20px;
      background: #fff;
      border-radius: 4px;
      border: 1px dashed #d9d9d9;

      .file-info {
        margin-top: 16px;
        font-size: 13px;
        color: #8c8c8c;
      }
    }

    .form-actions {
      margin-top: 30px;
      text-align: center;
      padding-top: 20px;
      border-top: 1px solid #e8e8e8;
    }
  }
}

.row {
  display: flex;
  margin-top: 25px;

  .item {
    margin-left: 50px;
    display: flex;
    // width: 600px;
    align-items: center;

    /deep/ .ant-upload {
      width: 200px;
      height: 122px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      cursor: pointer;
      padding: 0px;
      overflow: hidden;

      border: 1px dashed #d9d9d9 !important;
      background-color: #fafafa !important;

      .anticon-plus {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .ant-upload.ant-upload-select-picture-card {
      border: 1px solid #ccc;
    }

    .ant-upload.ant-upload-select-picture-card > .ant-upload {
      padding: 0;
    }

    .ant-upload-select-picture {
      width: 200px;
      height: 122px;
      border: 0;
    }
  }
}

.file-thumbnails {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.thumbnail-container {
  width: 80px;
  height: 80px;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border 0.2s;
}

.thumbnail-container:hover {
  border-color: #1890ff;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.thumbnail-pdf {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

</style>